import React, { Component } from "react";

class About extends Component {
  render() {
    if (!this.props.data) return null;

    const bio = this.props.data.bio;
    const area = this.props.data.address.area || this.props.data.address.city;
    const startDate = new Date(`${this.props.data.professionalStartDate}T00:00:00`);
    const today = new Date();
    const yearsSinceStart = today.getFullYear() - startDate.getFullYear()
      - (today < new Date(today.getFullYear(), startDate.getMonth(), startDate.getDate()) ? 1 : 0);
    const experienceBio = bio.replace("{yearsOfExperience}", yearsSinceStart);

    return (
      <section id="about" className="hero-section">
        <div className="hero-copy">
          <p className="eyebrow">Full Stack Software Engineer - {area} Area</p>
          <h1>Building thoughtful software from <span>concept to launch—and beyond.</span></h1>
          <p className="hero-bio">{experienceBio}</p>
        </div>
        <aside className="profile-summary" aria-label="Professional summary">
          <img className="monogram" src="/images/profilepic-optimized.jpg" alt="Michayla Ben-Ezra" loading="eager" fetchpriority="high" />
          <div className="summary-meta"><span>Based in the {area} area.</span><strong>{yearsSinceStart}+ yrs experience</strong></div>
        </aside>
      </section>
    );
  }
}

export default About;